<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>

        <div class="text-xs-center pt-2">
            <h2>Περίληψη Επιλογών</h2>
            <hr/>
        </div>

        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs4>
                    <v-btn :disabled="!$store.getters.newStatementAllow" @click="upDateDeclaration" color="info" round>
                        <v-icon>arrow_back_ios</v-icon>
                        <span>Τροποποίηση Δήλωσης</span>
                    </v-btn>
                </v-flex>
                <v-flex xs4>
                    <v-btn :disabled="checkedRedeemButton()" @click="upDateExchange" color="info" round>
                        <span>Τροποποίηση Εξαργύρωσης</span>
                    </v-btn>
                </v-flex>
                <v-flex xs4>
                    <v-btn @click.native="sendPointRequest" color="info" round>
                        <span>Συνέχεια</span>
                        <v-icon>arrow_forward_ios</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>

        <v-layout row>
            <v-flex offset-sm1 sm10 xs12>
                <v-card v-if="Object.keys($store.getters.checkedBooks).length > 0 || Object.keys($store.getters.redeemPoints).length > 0">
                    <v-list subheader two-line>
                        <v-subheader class="justify-center" v-if="util.checkBooksLength()">
                            Συγγράμματα Από Δήλωση
                        </v-subheader>

                        <DeclarationBooksComponent v-if="util.checkBooksLength()"/>

                        <v-divider inset></v-divider>

                        <v-subheader class="justify-center" v-if="util.redeemPointsLength()">
                            Συγγράμματα Από Εξαργύρωση
                        </v-subheader>
                        <RedeemBooksComponent v-if="util.redeemPointsLength()"/>
                    </v-list>
                    <br>
                </v-card>
                <v-card v-else>
                    <v-list subheader two-line>
                        <v-subheader class="justify-center red--text">
                            Δεν έχετε επιλέξει κάποιο μάθημα
                        </v-subheader>
                    </v-list>
                </v-card>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import DeclarationBooksComponent from "../ExtraComponents/DeclarationBooksComponent";
    import RedeemBooksComponent from "../ExtraComponents/RedeemBooksComponent";
    import requests from "../../requests";
    import _ from 'lodash'
    import util from "../../utilities"


    export default {
        name: "StatementBookListComponent",
        components: {RedeemBooksComponent, DeclarationBooksComponent},
        data() {
            return {
                urlParamsPoints:'',
                urlParamsMatch:'',
                checkAllBooks:false,
                allBooksId: [],
                util,
                semesterCoursesArray: [],
                point: []
            }
        },
        methods: {
            closeDialog() {
                this.$store.commit('setDialog', false)
            },

            upDateDeclaration() {
                if (!this.$store.getters.newStatementAllow) {
                    this.$store.commit('setLoadingModal', true);
                    requests.allBooksGroupByCourse(this.$store.getters.login.secretariat.id, this.createListOfBooksById);
                } else {
                    if (this.$store.getters.semesterData.length > 0) {
                        this.createListSemesterData();
                        this.$router.push({path: '/newStudentBookList'});
                    } else {
                        this.$store.commit('setLoadingModal', true);
                        requests.allBooksGroupByCourse(this.$store.getters.login.secretariat.id, this.createListOfBooksById);
                        this.$router.push({path: '/newStudentBookList'});
                    }
                }
            },

            upDateExchange() {
                if (!this.$store.getters.listOfBooksById.length) {
                    this.$store.commit('setLoadingModal', true);
                    requests.allBooksGroupByCourse(this.$store.getters.login.secretariat.id, this.createListOfBooks);
                } else {
                    this.$router.push({path: '/redeemPoints'});
                }

            },

            createListOfBooks(response) {
                this.$store.commit('setListOfBooksById', util.checkIfBookIsActiveFromSecretary(response));
                this.$store.commit('setLoadingModal', false);
                this.$router.push({path: '/redeemPoints'});
                this.createListSemesterData();
            },

            createListOfBooksById(response) {
                this.$store.commit('setListOfBooksById', util.checkIfBookIsActiveFromSecretary(response));
                this.$router.push({path: '/newStudentBookList'});
                this.createListSemesterData();
            },

            createListSemesterData() {
                var semesterArray = this.$store.getters.semesters;
                this.semesterCoursesArray = [];
                const courses = this.$store.getters.courses;
                for (let i = 0; i < semesterArray.length; i++) {
                    var semesterCourses = [];
                    var semester = semesterArray[i];

                    for (let j = 0; j < courses.length; j++) {
                        let courseItem = courses[j];
                        if (courseItem.semester === semester)
                            semesterCourses.push(courseItem);
                    }

                    this.semesterCoursesArray.push({semester: semester, courses: semesterCourses});
                }
                this.finalCoursesData()
            },

            // ToDo move to Utilities
            finalCoursesData() {
                const books = this.$store.getters.listOfBooksById;
                let semesterData = [];

                for (let i = 0; i < this.semesterCoursesArray.length; i++) {

                    var courseObject = [];
                    let courses = this.semesterCoursesArray[i].courses;
                    for (let j = 0; j < courses.length; j++) {

                        let courseBooks = [];
                        let courseInfo;
                        let bookExistsInChecked = false;
                        let bookId = null;

                        for (let z = 0; z < books.length; z++) {
                            if (books[z].courseId == courses[j].id && books[z].active === true) {
	                            if(books[z]['statementBookGroupType'] == null ){
		                            books[z]['statementBookGroupType'] = 'NORMAL';
	                            }
                                courseInfo = books[z].course;
                                courseBooks.push(books[z]);

                                if (this.$store.getters.checkedBooks[books[z].courseId] !== undefined) {
                                    bookId = this.$store.getters.checkedBooks[books[z].courseId].books.books[0].book.id;
                                    bookExistsInChecked = true;
                                }
                            }
                        }

                        if (courseInfo == null) {
                            courseInfo = courses[j];
                        }

                        courseObject.push({
                            courseIno: courseInfo,
                            courseBooks: courseBooks.sort((bookA, bookB) => (bookA.position < bookB.position) ? -1 : 1),
                            visibilityFlag: bookExistsInChecked,
                            radioValue: bookId,
                            courseRegistration: false
                        });
                    }
                    semesterData.push({semester: this.semesterCoursesArray[i].semester, semesterInfo: courseObject, courseRegistration: false});
                }

                this.$store.commit('setSemesterData', semesterData);
                this.$store.commit('setLoadingModal', false);
            },

            //create point params
            createPointsParams() {

                let checkedBooks = this.$store.getters.checkedBooks;
                let redeems = this.$store.getters.redeemPoints;

                this.urlParamsPoints = '';
                this.urlParamsMatch = '';

                for (var book in checkedBooks) {
                    if (checkedBooks.hasOwnProperty(book)) {
                        if (this.urlParamsPoints == '') {
                            this.allBooksId.push(checkedBooks[book].books.books[0].book.id);
                            this.urlParamsPoints = 'id=' + checkedBooks[book].books.id
                        } else {
                            this.allBooksId.push(checkedBooks[book].books.books[0].book.id);
                            this.urlParamsPoints = this.urlParamsPoints + ('&id=' + checkedBooks[book].books.id)
                        }
                        if (this.urlParamsMatch == '') {
                            this.urlParamsMatch = 'bookgroupId=' + checkedBooks[book].books.id
                        } else {
                            this.urlParamsMatch = this.urlParamsMatch + ('&bookgroupId=' + checkedBooks[book].books.id)
                        }
                    }
                }
                for (var redeem in redeems) {
                    if (redeems.hasOwnProperty(redeem)) {
                        if (this.urlParamsPoints == '') {
                            this.allBooksId.push(redeems[redeem].books.books[0].book.id);
                            this.urlParamsPoints = 'id=' + redeems[redeem].books.id
                        } else {
                            this.allBooksId.push(redeems[redeem].books.books[0].book.id);
                            this.urlParamsPoints = this.urlParamsPoints + ('&id=' + redeems[redeem].books.id)
                        }
                        if (this.urlParamsMatch == '') {
                            this.urlParamsMatch = 'bookgroupId=' + redeems[redeem].books.id
                        } else {
                            this.urlParamsMatch = this.urlParamsMatch + ('&bookgroupId=' + redeems[redeem].books.id)
                        }
                    }
                }

            },

            sendPointRequest() {

                if (!this.$store.getters.newStatementAllow) {

                    //check if statementAddress is exist and push to final page
                    if (this.$store.getters.studentAddressInformation){
                        util.setBookArraysByDistType(this.$store.getters.checkedBooks, true);
                        util.setBookArraysByDistType(this.$store.getters.redeemPoints, false);
                        this.$router.push({path: '/statementBookListReceipt'});
                        return;
                    }
                    // create point params
                    this.createPointsParams();

                    //check if urlParamsPoints is empty
                    if (this.urlParamsPoints != '') {
                        requests.points(this.urlParamsPoints, this.passPointsToStore);
                        this.$store.commit('setLoadingModal', true);
                    }

                    // this.$router.push({path: '/statementBookListReceipt'});
                }  else {

                    var temp = {};
                    this.$store.commit('setExchangeType', temp);
                    let checkedBooks = this.$store.getters.checkedBooks;
                    let redeems = this.$store.getters.redeemPoints;

                    if (Object.keys(checkedBooks).length === 0 &&
                        Object.keys(redeems).length === 0) {
                        this.$store.commit('setBooksFromCheckedByDistPoint', []);
                        this.$store.commit('setBooksFromCheckedByCourrier', []);
                        this.$store.commit('setBooksFromRedeemByDistPoint', []);
                        this.$store.commit('setBooksFromRedeemByCourrier', []);
                        this.$store.commit('setPinFlag', false);
                        this.$router.push({path: '/statementBookListReceipt'});

                        // Check if Courier component needs to be shown
                        util.checkCourierInfoFlag([], false);
                    } else {
                        // create point params
                        this.createPointsParams();

                        if (this.urlParamsPoints != '') {
                            requests.points(this.urlParamsPoints, this.passPointsToStore);
                            this.$store.commit('setLoadingModal', true);
                        }
                    }
                }
            },

            passPointsToStore(response) {
                this.point = _.mapValues(_.groupBy(response, 'bookId'),
                    clist => clist.map(response => _.omit(response, 'bookId')));
                this.$store.commit('setPoints', this.point);

                util.setBookArraysByDistType(this.$store.getters.checkedBooks, true);
                util.setBookArraysByDistType(this.$store.getters.redeemPoints, false);

                util.checkCourierInfoFlag(this.point);

                if (this.urlParamsMatch != '') {
                    requests.match(this.urlParamsMatch, this.passMatchToStore)
                }
            },

            passMatchToStore(response) {
                const temp = this.$store.getters.exchangeType;
                for (var i = 0; i < response.length; i++) {
                    if (temp[response[i].dstStatementBookId] === undefined) {
                        temp[response[i].dstStatementBookId] = {distributionPoints: {}, bookExchangeFlag: true}
                    }
                }
                this.$store.commit('setExchangeType', temp);
                this.$store.commit('setMatch', response);
                this.$store.commit('setLoadingModal', false);
                this.$router.push({path: '/statementBookListReceipt'});
            },

            checkedRedeemButton() {
                if (this.$store.getters.newStatementAllow === false) {
                    return true
                } else {
                    return this.$store.getters.login.exchangeCredits < 1;
                }
            }
        }
    }
</script>

<style scoped>

</style>
